import React, { useState } from "react";
import { createProductOrder } from "../../services/product.service";

function PlaceOrder(props) {
  const [payload, setPayload] = useState({
    name: "",
    phone: "",
    email: "",
    company_name: "",
    requirements: "",
    city: "",
    address: "",
  });
  const [msg, setMsg] = useState("");
  const [loading, toggleLoading] = useState(false);

  const handleChange = (key, value) => {
    setPayload({
      ...payload,
      [key]: value,
    });
  };
  const resetForm = () => {
    setPayload({
      name: "",
      company_name: "",
      phone: "",
      email: "",
      requirements: "",
      city: "",
      address: "",
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    toggleLoading(true);
    setMsg("");
    createProductOrder(payload)
      .then((resp) => {
        window.scrollTo(0, 0);
        if (resp?.data?.success) {
          console.log("sucess");
          toggleLoading(false);
          setMsg(
            "Your Order is submited, We'll contact you back soon. Thank you"
          );
          resetForm();
        } else {
          console.log("failed");
          toggleLoading(false);
          setMsg("Sorry there is some issue please try again later. Thank you");
          resetForm();
        }
      })
      .catch((err) => {
        window.scrollTo(0, 0);
        console.log("err", err);
        toggleLoading(false);
        setMsg("Sorry there is some issue please try again later. Thank you");
      });
  };
  return (
    <section id="main" className="entire_width">
      <div className="container_12">
        <div id="content">
          <div className="grid_12">
            <h1 className="page_title">Place Order</h1>
          </div>
          <div className="grid_8">
            {!!msg && (
              <div
                style={{
                  backgroundColor: msg.includes("Sorry") ? "red" : "#4BB543",
                  color: "white",
                  padding: 10,
                  marginTop: 10,
                  borderRadius: 5,
                }}
              >
                {msg ?? ""}
              </div>
            )}
            <form
              className="contact"
              onSubmit={handleSubmit}
              style={{ height: "110vh" }}
            >
              {/* <h2>Quick Contact</h2> */}
              <div className="name">
                <strong>Name:</strong>
                <sup className="surely">*</sup>
                <br />
                <input
                  disabled={loading}
                  type="text"
                  placeholder="Enter Name"
                  value={payload.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                  name="name"
                  required
                />
              </div>
              <div className="email">
                <strong>Company Name:</strong>
                <sup className="surely">*</sup>
                <br />
                <input
                  disabled={loading}
                  type="text"
                  placeholder="Enter Company Name"
                  value={payload.company_name}
                  onChange={(e) => handleChange("company_name", e.target.value)}
                  name="company_name"
                  required
                />
              </div>
              <div className="email">
                <strong>Email Address: </strong>
                <sup className="surely">*</sup>
                <br />
                <input
                  disabled={loading}
                  type="email"
                  placeholder="Enter Email Address"
                  value={payload.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                  name="email"
                  required
                />
              </div>
              <div className="phone">
                <strong>Contact Number</strong>
                <sup className="surely">*</sup>
                <br />
                <input
                  disabled={loading}
                  type="number"
                  name="phone"
                  placeholder="Enter Phone Number"
                  value={payload.phone}
                  onChange={(e) => handleChange("phone", e.target.value)}
                  required
                />
              </div>
              <div className="phone">
                <strong>City</strong>
                <sup className="surely">*</sup>
                <br />
                <input
                  disabled={loading}
                  type="text"
                  name="city"
                  placeholder="Enter City"
                  value={payload.city}
                  onChange={(e) => handleChange("city", e.target.value)}
                  required
                />
              </div>
              <div className="phone">
                <strong>Address:</strong>
                <sup className="surely">*</sup>
                <br />
                <textarea
                  style={{ marginBottom: 10 }}
                  name="address"
                  placeholder="Enter Address"
                  value={payload.address}
                  onChange={(e) => handleChange("address", e.target.value)}
                  required
                />
              </div>
              <div className="phone">
                <strong>Requirements:</strong>
                <sup className="surely">*</sup>
                <br />
                <textarea
                  style={{ marginBottom: 10 }}
                  name="comment"
                  placeholder="type your requirements"
                  value={payload.requirements}
                  onChange={(e) => handleChange("requirements", e.target.value)}
                  required
                />
              </div>
              <div className="submit">
                <div className="field">
                  <sup className="surely">*</sup>
                  <span>Required Field</span>
                </div>
                <input
                  type="submit"
                  value={loading ? "Loading..." : "Submit"}
                />
              </div>
            </form>
          </div>
        </div>
        <div className="clear" />
      </div>
    </section>
  );
}

export default PlaceOrder;
